import { BaseRequest } from 'Services/base';

export interface PublicKeyItem {
  key?: string;
  publicKey?: string;
  value?: string;
  [k: string]: string | undefined;
}

export interface ListPublicKeysResponse {
  items?: PublicKeyItem[];
}

export class ListPublicKeysRequest extends BaseRequest<ListPublicKeysResponse> {
  constructor() {
    super( {
      method: 'GET',
      url: '/settingservice/v1/public-keys',
      responseType: 'json',
    } );
  }
}
